import LeadsModal from './LeadModal';

export default LeadsModal;
